import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "../i18n/translations";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const { user } = useAuth();
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    if (user?.preferred_language && user.preferred_language !== lang) {
      setLangState(user.preferred_language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user_id]);

  const setLang = useCallback(async (next) => {
    setLangState(next);
    if (user) {
      try { await api.post("/auth/language", { language: next }); } catch (_) {}
    }
  }, [user]);

  const t = useCallback((key) => translations[lang]?.[key] || translations.en[key] || key, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
